import React from 'react'
import test from "../../imagens/imagensTestes/teste.jpeg"
import test2 from "../../imagens/imagensTestes/teste2.jpeg"
import test3 from "../../imagens/imagensTestes/teste3.jpeg"
import test4 from "../../imagens/imagensTestes/teste4.jpeg"
import test5 from "../../imagens/imagensTestes/teste5.jpeg"
import test6 from "../../imagens/imagensTestes/teste6.png"
import test7 from "../../imagens/imagensTestes/teste7.png"
import test8 from "../../imagens/imagensTestes/teste8.png"
import test9 from "../../imagens/imagensTestes/teste9.png"
import Header from '../../Components/Header'
import WireTestCapabilities from '../../Components/wireTestsCapabilities'

const listWireTest = [
    {
        img: test6
    },
    {
        img: test7
    },
    {
        img: test8
    },
    {
        img: test9
    },
    {
        img: test
    },
    {
        img: test2
    },
    {
        img: test3
    },
    {
        img: test4
    },
    {
        img: test5
    }
]



function WireTestPage() {
    return (
        <div>
            <Header />

                <WireTestCapabilities
                    listWireTest={listWireTest}
                />
        </div>
    )
}

export default WireTestPage